import clsx from 'clsx';
import React from 'react';

type Tab = {
  id: string;
  label: string;
  badge?: boolean;
};

type TabsProps = {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
};

export const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange, className = '' }) => {
  return (
    <div
      className={clsx('flex flex-col sm:flex-row justify-start items-start sm:items-center gap-4 sm:gap-8', className)}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={clsx(
              'text-lg font-semibold pb-2 cursor-pointer bg-transparent border-t-0 border-l-0 border-r-0 transition-colors flex items-center gap-2',
              isActive ? 'text-[#113D7B] border-b-2 border-[#113D7B]' : 'text-[#767676] border-b-0 hover:text-[#113D7B]'
            )}
          >
            {tab.label}
            {tab.badge && <div className="w-2 h-2 bg-[#BB8D03] rounded-full" />}
          </button>
        );
      })}
    </div>
  );
};
